import YesNoDescriptionInputGroup from './YesNoDescriptionInputGroup';
export default YesNoDescriptionInputGroup;